import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Компонент для автоматического скролла вверх при смене маршрута
 * Используется для улучшения UX при навигации между страницами
 */
const ScrollToTop = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		// Прокручиваем страницу вверх при смене маршрута
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth', // Плавная прокрутка
		});
	}, [pathname]); // Срабатывает при изменении pathname

	return null; // Компонент не рендерит ничего
};

export default ScrollToTop;

